import React from "react";

const AmountFlipCounter = ({ amount }) => (
  <div className="text-4xl text-white leading-none font-bold">
    {amount
      .toFixed(0)
      .toString()
      .split("")
      .map((number, index) => (
        <span
          key={index}
          className="inline-block px-2 rounded align-middle"
          style={{
            backgroundColor: "#FDCD1A",
            marginRight: "2px",
            lineHeight: "39px",
          }}
        >
          {number}
        </span>
      ))}
    <span
      className="inline-block px-1 rounded text-sm text-base align-middle"
      style={{
        backgroundColor: "#FDCD1A",
        marginRight: "2px",
        lineHeight: "39px",
      }}
    >
      RON
    </span>
  </div>
);

export default AmountFlipCounter;
